module.exports = __webpack_public_path__ + "static/media/second_irwin_conference_center2.541a41cb.png";